import React, {useState, useContext, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Typography from '@material-ui/core/Typography';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { LinearProgress } from '@material-ui/core';
import {getUSFullDate, getUSFullTime} from '../../../utilities/utils'

import * as EquipWorker from '../../../workers/equipWorker'
import { UsersContext } from '../../../context/users-context';
import { CurrentEquipContext } from '../../../context/currentEquip-context';

const useStyles = makeStyles((theme) => ({
  root: {
		position: "relative",
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
  commonSpacing:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textField: {    
    width: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  optionStyle:{
    // backgroundColor: "#3f51b5",
    // color:"black",
  },
	card: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		position: "relative",
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		paddingBottom: theme.spacing(3),
	},
	cardRow: {
		display: "flex",
    justifyContent: "space-around",
    alignItems: "self-end"
	},
  cardColumn: {
		display: "flex",
    justifyContent: "space-around",
		flexDirection: "column",
    alignItems: "top"
	},
	downloadSpeed: {
		display: "flex",
		flexDirection: "column",
		width: 200,
	},
	uploadSpeed: {
		display: "flex",
		flexDirection: "column",
		width: 200,
	},
	sendButton: {
		display: "flex",
		flexDirection: "column",
		width: 250,
	},
	speedValue: {
		fontSize: "1.25em",
	},
	commonSpacing: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	loader: {
		position: "absolute",
		bottom: 0,
		width: "100%",
		opacity: 0,
		transition: "opacity 0.3s",
		"&.visible": {
			opacity: 1,
		}
  },
  buttonText: {
    height: "20px"
  }
}));
export default function SummarySendToFtpServerInfoTabPanel(props) {
  console.log("render SummarySendToFtpServerInfoTabPanel");

  const classes = useStyles();
   const [usersState, usersDispatch] = useContext(UsersContext);
   const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);

  const [startDate, setStartDate] = useState(getUSFullDate(new Date("2022, 01, 01")));
    const [endDate, setEndDate] = useState(getUSFullDate(new Date()));

  const [startTime, setStartTime] = useState(getUSFullTime(new Date("2022, 01, 01")));
  const [endTime, setEndTime] = useState(getUSFullTime(new Date()));

  const [isEndDate, setIsEndDate] = useState(false);

  const [sendNewImage, setSendNewImage] = useState(false);
  const [settingsIsSaved, setSettingsIsSaved] = useState(true);

  const [uploadInfo, setUploadInfo] = useState({
		sentImagesCount: 0,
		imagesToSendCount: 0,
		inProcess: false,
	});

  const handleStartDateChange = (ev) => {
    setStartDate(ev.target.value);
   };

  const handleEndDateChange = (ev) => {
    setEndDate(ev.target.value);
  };

  const handleEndTimeChange = (ev) => {
    setEndTime(ev.target.value);
  };

  const handleStartTimeChange = (ev) => {
    setStartTime(ev.target.value);
  };

  const equipName = props.equipName;
  const token = usersState.token;

  const [imgTypes, setImgTypes] = React.useState({
    RawGraphy: false, 
    Graphy: false, 
    RawScopy: false, 
    Scopy: false
  });

  const { RawGraphy, Graphy, RawScopy, Scopy } = imgTypes;

  const handleImageTypesChange = (event) => {
    setSettingsIsSaved(false);
    setImgTypes({ ...imgTypes, [event.target.name]: event.target.checked });
  };

  const onSetIsEndDate= async (event) => {
		const value = !isEndDate;
		setIsEndDate(value);
	};

  const onSetSendingNewImage= async (event) => {
    setSettingsIsSaved(false);
		setSendNewImage(!sendNewImage);
	};

  useEffect(() => { 
    console.log(imgTypes);
  }, [imgTypes]);

  useEffect(async () => 
  { 
      if (props.currActive)
        await EquipWorker.GetFtpSettings(token, equipName);

  }, [props.currActive]);


  useEffect(() => {
    if (currEquipState.remoteaccess?.SendingImagesToFtpServerResult === undefined)
      return;
		(async () => {
			let sentImagesCnt = currEquipState.remoteaccess?.SendingImagesToFtpServerResult?.Item1;
			let imagesToSendCnt = currEquipState.remoteaccess?.SendingImagesToFtpServerResult?.Item2;

			setUploadInfo({
				sentImagesCount: sentImagesCnt,
				imagesToSendCount: imagesToSendCnt,
				inProcess: imagesToSendCnt > 0,
			});		

		})();
	  }, [currEquipState.remoteaccess?.SendingImagesToFtpServerResult]);

  useEffect(() => { 
    let ftpParams = currEquipState.remoteaccess?.FtpSettingsResult;
    if (ftpParams === null || ftpParams === undefined)
    {
      return;
    }
    setSendNewImage(ftpParams.SendNewImage);
    setImgTypes((prev) => ({
      ...prev,
      Graphy: ftpParams.Graphy, 
      Scopy:  ftpParams.Scopy,
      RawGraphy: ftpParams.RawGraphy,
      RawScopy: ftpParams.RawScopy
    }));
  }, [currEquipState.remoteaccess?.FtpSettingsResult]);

  const SendImages = async () => {  
    let strImgTypes = Object.keys(imgTypes).filter(item => imgTypes[item]).toString();
    setUploadInfo((prev) => ({
			...prev,
			sentImagesCount: 0,
			imagesToSendCount: 0,
			inProcess: true,
		}));

    let strStartDateTime = startDate + " " + (startTime.length === 4 ? "0" + startTime : startTime);
    let strEndDateTime = endDate + " " + (endTime.length === 4 ? "0" + endTime : endTime);
  
    await EquipWorker.SendImagesToFtpServer(token, equipName, strStartDateTime, strEndDateTime, strImgTypes);
   };

   const CancelSendingImages = async () => {  
    setUploadInfo((prev) => ({
			...prev,
			sentImagesCount: 0,
			imagesToSendCount: 0,
			inProcess: false,
		}));
    
    await EquipWorker.CancelSendingImagesToFtpServer(token, equipName)
   };

   const SaveSettings = async () => { 
     await EquipWorker.ChangeSendingParameters(token, equipName, sendNewImage, imgTypes.Graphy, imgTypes.Scopy, imgTypes.RawGraphy, imgTypes.RawScopy)
     setSettingsIsSaved(true);
  };

  return (
     <div className={classes.root}>
      <Card className={classes.card}>
      <CardContent className={`${classes.cardContent}`}>
        <div className={classes.cardRow}>
          <div  className={classes.cardColumn}>
          <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
              disabled={uploadInfo.inProcess}
              checked={RawGraphy}
                onChange={handleImageTypesChange}
                name="RawGraphy"
              />
            }
            label="Необработанное одиночное изображение"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Graphy}
                disabled={uploadInfo.inProcess}
                onChange={handleImageTypesChange}
                name="Graphy"
              />
            }
            label="Одиночное изображение"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={RawScopy}
                disabled={uploadInfo.inProcess}
                onChange={handleImageTypesChange}
                name="RawScopy"
              />
            }
            label="Необработанное серийное изображение"
          />

        <FormControlLabel
            control={
              <Checkbox
                checked={Scopy}
                disabled={uploadInfo.inProcess}
                onChange={handleImageTypesChange}
                name="Scopy"
              />
            }
            label="Серийное изображение"
          />  
          <FormControlLabel
						control={
							<Checkbox checked={sendNewImage} 
              disabled={uploadInfo.inProcess}
              onChange={onSetSendingNewImage} />
						}
            label="Отправлять новые изображения"
					/>

              <Button
								variant="contained"
								color="primary"
                disabled={uploadInfo.inProcess}
								onClick={SaveSettings}
								disabled={settingsIsSaved}
								>
								<div className={classes.buttonText}>Сохранить настройки</div>
							</Button>

      </FormGroup>
      
          </div>
        <div className={classes.cardColumn}>
      
      <TextField
          id="startDate"
          label="Начальная дата"
          type="date"
          defaultValue={startDate}
          onChange={handleStartDateChange}
          className={classes.textField, classes.commonSpacing}
          InputLabelProps={{
          shrink: true,
          }}
      />
      <TextField
          id="startTime"
          label="Время"
          type="time"
          defaultValue={startTime}
          onChange={handleStartTimeChange}
          className={classes.textField, classes.commonSpacing}
          InputLabelProps={{
          shrink: true,
          }}
      />
      </div>
      <div className={classes.cardColumn}>
      <FormControlLabel
						control={
							<Checkbox checked={isEndDate} 
              onChange={onSetIsEndDate} />
						}
            label="Задать конечные дата и время"
					/>
      <TextField
          id="endDate"
          label="Конечная дата"
          type="date"
          disabled={!isEndDate}
          defaultValue={endDate}
          onChange={handleEndDateChange}
          className={classes.textField, classes.commonSpacing}
          InputLabelProps={{
          shrink: true,
          }}
      />
      <TextField
          id="startTime"
          label="Время"
          type="time"
          disabled={!isEndDate}
          defaultValue={endTime}
          onChange={handleEndTimeChange}
          className={classes.textField, classes.commonSpacing}
          InputLabelProps={{
          shrink: true,
          }}
      />
      </div>
 
       <div className={classes.cardColumn}>
      <div className={classes.sendButton}>
							<Button
								variant="contained"
								color="primary"
								onClick={SendImages}
								disabled={uploadInfo.inProcess}
								>
								<div className={classes.buttonText}>Отправить за период</div>
							</Button>
						</div>
            <div className={classes.sendButton}>
							<Button
								variant="contained"
								color="primary"
								onClick={CancelSendingImages}
								disabled={!uploadInfo.inProcess}
								>
								<div className={classes.buttonText}>Отменить отправку</div>
							</Button>
						</div>
            </div>
      </div>

        </CardContent>
      </Card>
  
     
      <Card>
				<CardContent>
        <div className={classes.cardRow}>
						<div className={classes.downloadSpeed}>
							<Typography variant="h6">Отправлено</Typography>
							<div className={classes.speedValue}>{`${uploadInfo.sentImagesCount || "-"}`}</div>
						</div>
						<div className={classes.uploadSpeed}>
							<Typography variant="h6">Осталось отправить</Typography>
							<div className={classes.speedValue}>{`${uploadInfo.imagesToSendCount || "-"} `}</div>
						</div>
            </div>
				</CardContent>
				<div>
					<LinearProgress
						className={`${classes.loader} ${
							uploadInfo.inProcess ? "visible" : ""	}`}></LinearProgress>
				</div>
			</Card>
    </div>
   );
}